import React, { useEffect, useState } from "react";
import MainNavbar from "./MainNavbar";
import bgBlue from "../assets/images/bgGrey.jpg";
import { toast } from "react-toastify";
import { httpClient } from "../axios";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "@nextui-org/react";
import { useNavigate } from "react-router";
import { CheckCircle2, CreditCard } from "lucide-react";
import membershipExcel from "../assets/files/membership-benefits.pdf";

const Home = () => {
  const USER_DATA = JSON.parse(localStorage.getItem("userData"));
  const [transactionDetails, setTransactionDetails] = useState([]);

  const navigate = useNavigate();

  const config = {
    headers: {
      Authorization: `Bearer ${USER_DATA?.token}`,
    },
  };

  useEffect(() => {
    getuserDetails();
  }, []);

  const getuserDetails = () => {
    const req = { username: USER_DATA?.username };
    httpClient
      .post("/getUserDetailbyEmail", req)
      .then((res) => {
        try {
          if (res.data.statusCode === 200) {
            setTransactionDetails(res.data.result);
          }
        } catch (err) {
          toast.error("Something went wrong");
        }
      })
      .catch(() => toast.error("Something went wrong"));
  };

  const goToCheckout = () => {
    navigate("/checkout", { state: { email: USER_DATA?.username } });
  };

  const downloadExcel = () => {
    const link = document.createElement("a");
    link.href = membershipExcel;
    link.download = "membership-benefits.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      className="min-h-screen w-full bg-cover bg-no-repeat overflow-hidden flex flex-col"
      style={{
        backgroundImage: `url(${bgBlue})`,
      }}
    >
      <MainNavbar />

      <div className="flex flex-1 flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-4 md:py-6">
        <div className="w-full max-w-5xl space-y-6">
          {/* Welcome Section */}
          <div className="text-center">
            <h1 className="text-[#1D1D1F] text-2xl sm:text-3xl md:text-4xl font-semibold mb-2">
              Welcome{" "}
              {transactionDetails.length > 0
                ? transactionDetails[0]?.firstname
                : USER_DATA?.companyname}
              !
            </h1>
            <h2 className="text-[#1D1D1F] text-lg sm:text-xl font-medium mb-4">
              Your IACF Membership ID is –{" "}
              <span className="font-semibold">{USER_DATA?.usercode}</span>
            </h2>
          </div>

          {/* Membership Info Card */}
          <Card className="w-full md:w-[40rem] mx-auto text-center shadow-lg border border-gray-200 bg-white/80 backdrop-blur-sm">
            <CardHeader className="flex flex-col gap-1 py-3">
              <h3 className="text-xl sm:text-2xl font-semibold text-[#1D1D1F]">
                Plan:{" "}
                <span className="font-bold text-blue-600">
                  Annual Membership
                </span>
              </h3>
            </CardHeader>
            <CardBody className="px-4 sm:px-6">
             {/* <p className="text-sm sm:text-base text-gray-600 mt-1 italic">
                <span className="font-bold">Validity –</span> 12 Months after
                confirmation by IACF Membership Committee
              </p>*/}
              <p className="text-sm sm:text-base text-gray-600 italic">
                <span className="text-red-600">*</span> Subject to receipt of
                payment, review by IACF Membership Committee, and confirmation.
              </p>

              {/* Disclaimer */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mt-5 bg-blue-50 text-blue-800 p-3 rounded-lg border border-blue-200">
                <CreditCard className="text-blue-600" size={20} />
                <span className="text-sm sm:text-base font-medium text-center sm:text-left">
                  If the payment is still pending, kindly complete it.
                </span>
              </div>
            </CardBody>

            <CardFooter className="flex justify-center py-3">
              <Button
                onClick={goToCheckout}
                color="primary"
                variant="shadow"
                className="text-white px-8 w-full sm:w-auto text-base"
              >
                Proceed to Payment
              </Button>
            </CardFooter>
          </Card>

          {/* Membership Benefits Section */}
          <div className="w-full md:w-[40rem] mx-auto bg-white/80 backdrop-blur-sm p-4 sm:p-6 rounded-xl shadow-md">
            <h3 className="text-xl sm:text-2xl font-semibold text-[#1D1D1F] mb-4 text-center">
              Membership Benefits
            </h3>
            <ul className="space-y-2 text-gray-700 text-sm sm:text-base">
            <li className="flex items-start gap-2">
                <CheckCircle2 className="text-green-600 mt-1" size={18} />
                Valid for 12 Months after confirmation by IACF Membership Committee
              </li>

              <li className="flex items-start gap-2">
                <CheckCircle2 className="text-green-600 mt-1" size={18} />
                IACF Membership isn’t just for you — it’s for your entire family!
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="text-green-600 mt-1" size={18} />
                50% discount on Gala tickets.
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="text-green-600 mt-1" size={18} />
                50% discount on advertisements at all IACF events.
              </li>
            </ul>

            <p className="mt-4 text-center text-gray-700 text-sm sm:text-base">
              For more details,{" "}
              <button
                onClick={downloadExcel}
                className="text-blue-600 underline hover:text-blue-800 font-medium"
              >
                click here
              </button>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
